import React, { useState } from 'react'

import Logo from '../assets/logo.svg'
import { Icon } from './common'
import { NavLink, Link, useHistory } from 'react-router-dom'

import { NotificationsStore, AuthStore } from '../store'
import { observer } from 'mobx-react-lite'

import Notifications from './Notifications'
import { useText, useLang } from '../texts'

const Navigation = observer(() => {
  const history = useHistory()
  const allowUsers = AuthStore.getPermission('users')
  const t = useText()
  const { lang, defaultLang } = useLang()
  const pathEnd = defaultLang === lang ? '' : '?lang=' + lang

  return (
    <nav className="navigation">
      <Link to={'/' + pathEnd} className="navigation__logo">
        <img src={Logo} alt="Logo" />
      </Link>
      {AuthStore.currentUser && (
        <div className="navigation-content">
          <NavLink exact to={'/' + pathEnd} className="navigation__link">
            <Icon icon="map" height="3rem" width="4rem" />
            {t('navigation-map')}
          </NavLink>
          <NavLink to={'/analytics' + pathEnd} className="navigation__link">
            <Icon icon="analytics" height="3rem" width="4rem" />
            {t('navigation-analytic')}
          </NavLink>
          {allowUsers && (
            <NavLink to={'/users' + pathEnd} className="navigation__link">
              {t('navigation-users')}
            </NavLink>
          )}
          <div className="navigation-content__right">
            <div>
              <div className="navigation__username">
                {`${AuthStore.currentUser?.firstName} ${AuthStore.currentUser?.surname}`}
              </div>
              {/* <Link to="/edit-profile" className="navigation__edit-profile">
                Редактировать профиль
              </Link> */}
            </div>
            <div className="navigation__avatar"></div>
            <div className="navigation-btns">
              <div
                onClick={NotificationsStore.toggleNotifications}
                className="navigation__btn"
              >
                <Icon icon="notifications" size="2.5rem" />
                {NotificationsStore.notifications.length > 0 && (
                  <div className="notification__btn-label">
                    {NotificationsStore.notifications.length}
                  </div>
                )}
              </div>
              <div
                onClick={() => {
                  AuthStore.signOut()
                  history.push('/signIn' + pathEnd)
                }}
                className="navigation__btn"
              >
                <Icon icon="logout" size="2.5rem" />
              </div>
              <LangDropdown />
            </div>
          </div>
        </div>
      )}
      <Notifications />
    </nav>
  )
})

export default Navigation

const LangDropdown = () => {
  const [open, setOpen] = useState(false)
  const { lang, langs, setLang } = useLang()

  return (
    <div className={`lang-dropdown  ${open ? 'open' : ''}`}>
      <div
        className="lang"
        onClick={() => {
          setOpen(!open)
        }}
      >
        {lang}
        <svg
          className="arrow"
          viewBox="0 0 10 6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4.88621 5.16663L0.53887 0.166626L9.23355 0.166627L4.88621 5.16663Z"></path>
        </svg>
      </div>

      <div className="lang-dropdown-content">
        {langs
          .filter((l) => l !== lang)
          .map((l) => (
            <div
              onClick={() => {
                setLang(l)
                setOpen(false)
              }}
            >
              {l}
            </div>
          ))}
      </div>
    </div>
  )
}
